import React, { useEffect, useState } from 'react';
import { Chart, registerables } from 'chart.js';
import { View, Image, Text } from '@react-pdf/renderer';

Chart.register(...registerables);

const generateRadialQuadrantChart = () => {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.document) {
      const canvas = window.document.createElement('canvas');
      canvas.width = 900;
      canvas.height = 700;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Could not get canvas context'));
        return;
      }

      const colors = [' #C99212', ' #B6111F', ' #00577D', ' #667F96'];
      const labels = ['Strategic', 'Performance', 'Visionary', 'Collaborative'];
      const data = [14, 35, 22, 29 ];

      ctx.save();
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const maxRadius = 250;
      const whiteLineWidth = 10; // Width of the white separation line

      const maxValue = Math.max(...data);
      const radiusScale = maxRadius / maxValue;
      const angles = [-Math.PI / 2, 0, Math.PI / 2, Math.PI];
      
      // Clear the canvas with white background
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw quadrants with separation
      ctx.strokeStyle = 'white';
      ctx.lineWidth = whiteLineWidth;
      
      data.forEach((value, index) => {
        const radius = value * radiusScale;
        const startAngle = angles[index];
        const endAngle = startAngle + (Math.PI / 2);

        // Draw quadrant
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.lineTo(centerX, centerY);
        ctx.closePath();
        ctx.fillStyle = colors[index];
        ctx.fill();

        // Draw separation line to the edge of the chart
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        const outerX = centerX + maxRadius * Math.cos(startAngle);
        const outerY = centerY + maxRadius * Math.sin(startAngle);
        ctx.lineTo(outerX, outerY);
        ctx.strokeStyle = 'white';
        ctx.lineWidth = whiteLineWidth;
        ctx.stroke();

        // Add percentage text
        const midAngle = (startAngle + endAngle) / 2;
        const textX = centerX + (radius * 0.7) * Math.cos(midAngle);
        const textY = centerY + (radius * 0.7) * Math.sin(midAngle);

        ctx.fillStyle = 'white';
        ctx.font = 'bold 22px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`${value}%`, textX, textY);
      });

      // Add labels
      ctx.fillStyle = 'black';
      ctx.font = 'bold 28px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

    ctx.fillText('Strategic', centerX - maxRadius - 40, centerY - maxRadius);
    ctx.fillText('Performance', centerX - maxRadius - 40, centerY + maxRadius);
    ctx.fillText('Visionary', centerX + maxRadius + 40, centerY - maxRadius);
    ctx.fillText('Collaborative', centerX + maxRadius + 40, centerY + maxRadius);

      ctx.restore();
      resolve(canvas.toDataURL('image/png'));
    } else {
      reject(new Error('Window or document object not available'));
    }
  });
};

const LeadershipChart = () => {
  const [chartImage, setChartImage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    generateRadialQuadrantChart()
      .then(setChartImage)
      .catch(setError);
  }, []);

  if (error) {
    return (
      <View style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        width: '100%' 
      }}>
        <Text>Error generating chart: {error.message}</Text>
      </View>
    );
  }

  return (
    <View style={{
      flexDirection: 'row', 
      alignItems: 'left', 
      justifyContent: 'left', 
      // width: '100%',
      margin: 0,
      padding: 0
    }}>
      {chartImage ? (
        <Image 
          src={chartImage} 
          style={{ 
            width: 320, 
            height: 260, 
            alignSelf: 'left' 
          }} 
        />
      ) : (
        <Text>Loading chart...</Text>
      )}
    </View>
  );
};

export default LeadershipChart;